module.exports = __webpack_public_path__ + "static/media/maestro.283a9f7a.svg";